import { METRIC_NAMES } from '@config/Consts';

class AgentStatusMetricsModel {
  constructor(options) {
    if (options[METRIC_NAMES.LOAD_CONVERSATIONS] !== undefined) {
      this[METRIC_NAMES.LOAD_CONVERSATIONS] = options[METRIC_NAMES.LOAD_CONVERSATIONS];
    }
    this[METRIC_NAMES.ASSIGNED_CONVERSATIONS] = options[METRIC_NAMES.ASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.NUM_AWAY_AGENTS] = options[METRIC_NAMES.NUM_AWAY_AGENTS];
    this[METRIC_NAMES.NUM_BACK_SOON_AGENTS] = options[METRIC_NAMES.NUM_BACK_SOON_AGENTS];
    this[METRIC_NAMES.NUM_ONLINE_AGENTS] = options[METRIC_NAMES.NUM_ONLINE_AGENTS];
  }
}

export default AgentStatusMetricsModel;
